import { render, staticRenderFns } from "./EcommerceDeliveredFailed.vue?vue&type=template&id=78859997&scoped=true&"
import script from "./EcommerceDeliveredFailed.vue?vue&type=script&lang=js&"
export * from "./EcommerceDeliveredFailed.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceDeliveredFailed.vue?vue&type=style&index=0&id=78859997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78859997",
  null
  
)

export default component.exports